exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-file-label[data-v-abd4df3e]::after{\n    background-color: rgb(28,134,154);\n    color: white;\n    border-radius: 10px;\n    cursor: pointer;\n}\n", ""]);

// exports
